export enum ESize {
  'S' = 'S',
  'M' = 'M',
}
